import { html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { AppComponent } from '../component';
import { DashboardAdapter } from './dashboardAdapter';
import { Dashboard as OGDashboard } from '@omegagrid/dashboard';

@customElement('rp-dashboard')
export class Dashboard extends AppComponent {

	static styles = [AppComponent.styles, css`
		:host {
			display: block;
			width: 100%;
			height: 100%;
		}

		og-dashboard {
			width: 100%;
			height: 100%;
		}	
	`];

	@property({type: Object})
	adapter: DashboardAdapter;

	@query('og-dashboard')
	dashboard: OGDashboard;

	async updated(props: Map<string, unknown>) {
		super.updated(props);
		if (props.has('adapter') && this.adapter) {
			this.dashboard.setSourceData({
				items: await this.adapter.getItems(),
				options: await this.adapter.getOptions(),
			});
		}
	}
	
	render = () => html`
		<og-dashboard></og-dashboard>
	`;
	
}
